import React from "react";
import { Stack, Button, CircularProgress } from "@mui/material";

const LoadMore = ({ visible, loading, onClick }) => {
  if (!visible) return null;
  return (
    <Stack alignItems="center" sx={{ py: 2 }}>
      <Button onClick={onClick} disabled={loading} variant="outlined">
        {loading ? <CircularProgress size={20} /> : "Load more"}
      </Button>
    </Stack>
  );
};

export default LoadMore;
